import {
  SiUpwork,
  SiTwitter,
  SiLinkedin,
  SiGithub,
  SiInstagram,
} from "react-icons/si";

export const links = [
  {
    icon: <SiUpwork />,
    link: "https://www.upwork.com/freelancers/~0162592c7f1a31fe45?viewMode=1",
    name: "UpWork",
  },
  {
    icon: <SiTwitter />,
    link: "https://twitter.com/DevlprZee",
    name: "Twitter",
  },
  {
    icon: <SiLinkedin />,
    link: "https://www.linkedin.com/in/ziya-sayed-903687236/",
    name: "LinkedIn",
  },
  {
    icon: <SiGithub />,
    link: "https://github.com/ZiyaSayed",
    name: "GitHub",
  },
  {
    icon: <SiInstagram />,
    link: "https://www.instagram.com/devlopr_zee/",
    name: "Instagram",
  },
];
